import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import { isAustraliaResHub } from "@/utils/projectConfig";

export interface Reports {
  name: string;
  route: string;
  icon: string;
  accessLevels?: StaffAccessLevels[];
}

const allReports: Reports[] = [
/*  {
    name: "Reports.VisitsReport",
    route: "reportVisit",
    icon: "account-group"
  },*/
  {
    name: "Reports.LifestyleEventsReport",
    route: "lifestyleEventsReport",
    icon: "basketball-hoop-outline",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.HomeUser]
  },
  {
    name: "Reports.LifestyleProgramsReport",
    route: "report-lifestyle-programs-report",
    icon: "basketball",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin]
  },
  /*
  Temporary disabled from 01-08-2023
  {
    name: "Reports.SocialEventsReport",
    route: "reportEvents",
    icon: "widgets"
  },*/
  {
    name: "Reports.PremiumServiceReports",
    route: "premium-service-reports",
    icon: "star-circle",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.HomeUser]
  },
  {
    name: "Reports.ServiceRequestReport",
    route: "reportRequests",
    icon: "face-agent",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.HomeUser]
  },
  {
    name: "Reports.Resident360Report",
    route: "reports360",
    icon: "face-man",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.HomeUser]
  },
  /*{
    name: "Reports.FamilyMembersReport",
    route: "family-members-report",
    icon: "account-group"
  },*/
  {
    name: "Reports.FamilyReport",
    route: "family-report",
    icon: "account-group",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.HomeUser]
  },
  {
    name: "Reports.OrganisationalHealthDashboard",
    route: "report-organisational-health-dashboard",
    icon: "home-group",
    accessLevels: [StaffAccessLevels.OrgAdmin]
  },
  {
    name: "Reports.ActivitiesReport",
    route: "adHocActivitiesReport",
    icon: "calendar-heart-outline",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin]
  },
  {
    name: "Reports.CommunityHealthDashboard",
    route: "report-community-health-dashboard",
    icon: "home",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin]
  },
  {
    name: "Reports.Maintenance",
    route: "report-maintenance",
    icon: "wrench",
    accessLevels: [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin, StaffAccessLevels.MaintenanceAdmin]
  }
];

/**
 * Get reports list with project-specific filtering applied
 */
export const reportsItems = (): Reports[] => {
  return allReports.filter(report => {
    // Hide Maintenance report for Australia ResHub
    if (report.route === 'report-maintenance' && isAustraliaResHub()) {
      return false;
    }
    return true;
  });
};
